<template>
  <div>
    <h2 class="step-name">Review Sick Cows</h2>

    <div class="step-section">
      <h3>Avg. Per Cow Spend on Vet Examinations (VFD 115) </h3>
      <h4>Period 1 st June – 31 st October</h4>
      <bar :chart-data="chartData" :options="chartOptions" ></bar>
    </div>

    <div class="step-section">
      <h3>Vet Examinations (VFD 115)</h3>
      <h4>Period 1st June – 31st October 4 Seasons</h4>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Date</th>
            <th>Spend</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rv, index) in model.CHARTS.sick_cows_table" :key="index"
            :class="getRowClass(model.CHARTS.sick_cows_table, 'Date', index)">

            <td class="text-left">{{ rv["Date"] }}</td>
            <td class="text-left">{{ rv["Spend"] }}</td>
            <td class="text-left">{{ rv["Description"] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-section">
      <div class="form-group">
        <label for="sickcows_keypoints">Key Points</label>
        <textarea rows="5" cols="50" v-model="model.sickcows_keypoints" class="form-control" :disabled="isReadOnly">
        </textarea>
      </div>

      <div class="form-group">
        <label for="sickcows_actions">Actions</label>
        <textarea rows="5" cols="50" v-model="model.sickcows_actions" class="form-control" :disabled="isReadOnly">
        </textarea>
      </div>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component'
import Bar from '../../charts/Bar'

export default {
  mixins: [ baseComponent ],
  components: {
    Bar,
  },
  data() {
    return {
      model: {
        sickcows_keypoints: "",
        sickcows_actions: "",
        CHARTS: {
          sick_cows: [],
          sick_cows_table: [],
        },
      },
    }
  },
  computed: {
    chartOptions: function () {
      return {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Dollars'
            }
          }]
        }
      }
    },

    chartData: function () {
      return {
        labels: this.model.CHARTS.sick_cows.map(row => row['Season']),
        datasets: [
          {
            label: "This Farm",
            backgroundColor:  "#3e95cd",
            data: this.model.CHARTS.sick_cows.map(row => row['Per Cow Spend']),
          },
          {
            label: "Region",
            backgroundColor:  "#c45850",
            data: this.model.CHARTS.sick_cows.map(row => row['Region Avg. Per Cow Spend']),
          },
        ],
      }
    },
  },
};
</script>
